import React, { useState, useEffect } from 'react';
import { Input } from 'components/shared/FormComponent';
import { Empty, message, Popconfirm, Table, Tooltip } from 'components/shared/AntComponent';
import SearchIcon from 'assets/img/search.svg';
import { DeleteFilled } from 'components/shared/AntIcons';
import { Button } from 'components/shared/ButtonComponent';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/table.scss';
import { EditIcon } from 'assets/img/custom-icons';
import { getTemplates, removeTemplateManager } from 'services/actions/templateManagerAction';

interface DataType {
    key: any;
    sno: number;
    id: any;
    encrypt_templateNumber: any;
    template_name: any;
    template_category: any;
    template_type: any;
    status: any;
    action: any;
}

const TemplateManager: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userRole = sessionStorage.getItem('role');
    const { userProfileInfo } = useSelector((state: any) => state.auth);
    const { templateInfo, loading, loading2, error2, success2 } = useSelector((state: any) => state.template);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isStatus, setIsStatus] = useState('Active');
    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');
    const [searchTableVal, setsearchTableval] = useState('');
    const data = !loading && templateInfo?.data ? templateInfo?.data : [];
    const totalPage = !loading && templateInfo?.data ? templateInfo?.data : 0;
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success2 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error2 : false;

    const customLocale = {
        emptyText: <Empty className="p-2" description="No Template available" />,
    };

    const columns: any['columns'] = [
        {
            title: 'S.no',
            dataIndex: 'sno',
            key: 'sno',
            render: (id: number, record: any, index: number) => {
                if (pageIndex === 1) {
                    return index + 1;
                } else {
                    return (pageIndex - 1) * pageSize + (index + 1);
                }
            },
        },
        // {
        //     title: 'Template No',
        //     dataIndex: 'encrypt_templateNumber',
        //     key: 'encrypt_templateNumber',
        //     render: (_: any, record: any) => (
        //         <div>{record?.encrypt_templateNumber || "--"}</div>
        //     )
        // },
        {
            title: 'Template Name',
            dataIndex: 'name',
            key: 'name',
            filteredValue: [searchTableVal],
            onFilter: (value: any, record: any) => record?.name?.toLowerCase().includes(value.toLowerCase()),
            sorter: (a: any, b: any) =>
                (a?.name || '').toLowerCase().localeCompare((b?.name || '').toLowerCase()),

        },
        {
            title: 'Template Category',
            dataIndex: 'template_category',
            key: 'template_category',
            render: (id: any, record: any) => {
                return record.category_id == 1 ? "Invoice processed" : record.category_id==2?"Invoice due":
                record.category_id==3?"Invocie reminder":record.category_id==4?"New request":record.category_id==5?"Request released":
                record.category_id==6?"Password expired":record.category_id==7?"OTP":record.category_id==8?"Credit card expires":
                record.category_id==9?"Forgot password":record.category_id==10?"Invoice generation":record.category_id==11?"Payment success":
                record.category_id==12?"New account request":record.category_id==13?"Patient consent form": "--";
            },
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'is_active',
            align: 'center',
            render: (_: any, record: any) => {
                const val = record?.is_active ? 'Active' : 'Inactive';
                if (val === 'Active') {
                    return <div className='status-section mx-auto'><Button className="success-btn fw-bold text-center mx-auto px-2">{val}</Button></div>;
                } else {
                    return <div className='status-section mx-auto'><Button className="danger-btn text-center mx-auto px-2 text-capitalize">{val}</Button></div>;
                }
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            className: 'action-column',
            // align:'center',
            render: (_id: any, record: any) => {
                return (
                    <div
                        className=" text-center d-flex justify-content-center"
                        onClick={(event) => {
                            event.stopPropagation();
                        }}
                    ><Tooltip title="Edit" className="mt-0">
                            <div className="fs-20 edit-icon pointer my-auto me-1 text-success pb-1"
                                onClick={() => {
                                    handleEditScreen(record)
                                    // setOpenModal(true);
                                    // setRowData(record);
                                    // setModalTitle('Update Amplifier');
                                }}
                            >
                                <EditIcon />
                            </div   >
                        </Tooltip>
                        {/* <Tooltip title="Delete" className="mt-0">
                            <DeleteFilled className="fs-18 text-danger" onClick={() => handleOpenDelModal(record)} />
                        </Tooltip> */}
                        {(userRole === 'researcher' || userProfileInfo?.data?.sub_roll === 'researcher') ? (
                            <DeleteFilled className="text-secondary" />
                        ) : (
                            <Popconfirm
                                placement="topLeft"
                                title="Are you sure to delete this template?"
                                // description="Delete the patient"
                                onConfirm={() => {
                                    confirmDelete(record.id);
                                    // setShowSuccessmsg1(true);
                                    // setShowErrormsg1(true);
                                }}
                                okText="Yes"
                                cancelText="No"
                            >
                                <Tooltip title="Delete" className="mt-0">
                                    <DeleteFilled className="fs-18 text-danger" />
                                </Tooltip>
                            </Popconfirm>
                        )}
                    </div>
                );
            },
        },
    ];

    const confirmDelete = (val: any) => {
        const inputJson =
            { "template_id": Number(val) }

        dispatch(removeTemplateManager(inputJson) as any);
        setShowErrormsg(true);
        setShowSuccessmsg(true);
    }

    useEffect(() => {
        if (successmsg) {
            message.success("Template deleted successfully");
            setShowSuccessmsg(false);
            getAllTemplates();
        }
        if (errormsg) {
            if (error2?.data) {
                message.error(error2?.data);
            } else {
                message.error("Template couldn't be deleted");
            }
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);

    const tableChange = (pagination: any, ...sorted: any) => {
        let sort = '',
            sortfield = '';
        if (sorted[1].order === 'ascend') {
            sort = 'asc';
        } else if (sorted[1].order === 'descend') {
            sort = 'desc';
        } else sort = '';
        setPageIndex(pagination.current);
        if (sort == '') {
            sortfield = '';
            setSortField('');
        } else {
            setSortField(sorted[1].field);
            sortfield = sorted[1].field;
        }
        setSortOrder(sort);
        setPageSize(pagination.pageSize);
        // getAccount(searchTableVal, pagination.current, pagination.pageSize, sortfield, sort, isStatus);
    };
    const handleSearch = (e: any) => {
        if (e.key === 'Enter') {
            const searchValue = e.target.value.trim();
            setsearchTableval(searchValue)
            setPageIndex(1);
            // getAccount(e.target.value, 1, pageSize, '', '', isStatus);
        }
    };

    const resetSearch = (e: any) => {
        if (e.key === 'Backspace' && !e.target.value) {
            setsearchTableval('');
            setPageIndex(1);
            // getAccount(e.target.value, 1, pageSize, '', '', isStatus);
        }
    };

    const searchbyBtn = () => {
        setPageIndex(1);
        // getAccount(searchTableVal, 1, pageSize, '', '', isStatus);
    };
    const handleOpenDelModal = (val: any) => {

    }

    const getAllTemplates = () => {
        const inputJson = {
            "accountid": 0,
            "template_id": 0
        }
        dispatch(getTemplates(inputJson) as any);
    }

    useEffect(() => {
        getAllTemplates();
    }, []);

    const handleShowAddScreen = () => {
        // setShowAdd(true);
        navigate('/add-template-manager', { state: { rowData: null } });
    }

    const handleEditScreen = (record) => {
        navigate('/add-template-manager', { state: { rowData: record } })
    }

    return (
        <div className='p-3'>
            <div className="d-flex grid-title-card">
                <h5 className="my-auto ">Template Manager</h5>

                <div className="ms-auto d-flex title-btn">
                    {/* <Radio.Group defaultValue={isStatus} buttonStyle="solid" className="col pe-0 me-2 text-end" onChange={handleStatusChange}>
                        <Radio.Button className="active" value="Active">
                            Active
                        </Radio.Button>
                        <Radio.Button className="inactive px-2" value="InActive">
                            Inactive
                        </Radio.Button>
                    </Radio.Group> */}
                    <Input
                        prefix={<img src={SearchIcon} height="14px" onClick={searchbyBtn} />}
                        onKeyDown={(e) => handleSearch(e)}
                        value={searchTableVal}
                        onChange={(e) => setsearchTableval(e.target.value.replace(/^\s+/, ''))}
                        onKeyUp={(e) => resetSearch(e)}
                        className="search-input me-2 col px-2 rounded fs-14"
                        placeholder="Search"
                    />
                    {userRole == 'researcher' || userProfileInfo?.data?.sub_roll === 'researcher' ? '' : <Tooltip title="Add new template">
                        <Button type="primary" onClick={handleShowAddScreen} className="add-btn">
                            Add
                        </Button>
                    </Tooltip>}
                </div>

            </div>
            <div className="my-2">
                <Table
                    rowKey="id"
                    className="pointer border"
                    columns={columns}
                    dataSource={loading ? [] : data}
                    loading={loading}
                    onChange={tableChange}
                    scroll={{ x: 'calc(230px + 50%)' }}
                    locale={customLocale}
                    // onRow={(record: any) => {
                    //     return {
                    //         onClick: () => {
                    //             navigateNextScreen(record?.id);
                    //         },
                    //     };
                    // }}
                    pagination={{
                        current: pageIndex,
                        pageSize: pageSize,
                        total: totalPage,
                    }}
                />
            </div>

        </div>
    )
}

export default TemplateManager;